import { render, staticRenderFns } from "./scheduleClassesWeek.vue?vue&type=template&id=ea0c7752&scoped=true"
import script from "./scheduleClassesWeek.vue?vue&type=script&lang=js"
export * from "./scheduleClassesWeek.vue?vue&type=script&lang=js"
import style0 from "./scheduleClassesWeek.vue?vue&type=style&index=0&id=ea0c7752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0c7752",
  null
  
)

export default component.exports